import React from 'react';

import Icon from 'src/components/ui/Icon';

import { colours } from 'src/constants/colours';
import { styledTag } from 'src/utils/styled';

const ArrowContainer = styledTag('div')`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 20;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    border-radius: 2.5rem;
    background-color: ${colours.white.main}B3;
`;

type Props = {
    side: 'left' | 'right';
    top?: string;
    left?: string;
    right?: string;
    onClickHandler: (ev: React.MouseEvent) => void;
};

const ArrowForCarousel: React.FC<Props> = ({ side, onClickHandler, top, left, right }) => (
    <ArrowContainer className="carousel-arrow" style={{ left, top, right }} onClick={onClickHandler}>
        <Icon
            name={side === 'left' ? 'ChevronLeft' : 'ChevronRight'}
            color={colours.black.main}
            onClick={onClickHandler}
            size="0.69rem"
        />
    </ArrowContainer>
);

export default ArrowForCarousel;
